export default __webpack_public_path__ + "static/media/line-topbar-black.4d4c13e6.svg";